<template>
  <div>

    <h3 class="my-3 font-weight-bold">Mes participants à {{ mainStore.module.nom }}</h3>
    <v-alert v-if="!has_commandes" class="my-3" border="start" border-color="red-darken-4" elevation="0">Vous n'avez pas
      encore inscrit de participant à cet évenement</v-alert>
    <div v-if="has_commandes">
      <GlobalActionsCardCommande></GlobalActionsCardCommande>
      <div class="text-h6">Mes commandes
        <v-chip class="ml-2" color="primary-dark" variant="flat" size="small">{{ list_commandes.length }}</v-chip>
      </div>
      <CommandeItem class="my-4" v-for="item in list_commandes" :item="item" :key="item.id"></CommandeItem>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import CommandeItem from "./Commande_Item.vue";
import GlobalActionsCardCommande from "./Global_Actions_Card_Commande.vue";
import UserService from "@/services/user.service.js";

export default {
  components: {
    CommandeItem,
    GlobalActionsCardCommande,
  },
  data() {
    return {
      fiche_coureur: {},
    };
  },
  computed: {
    ...mapStores(useMainStore),
    list_commandes() {
      return this.fiche_coureur?.list || [];
    },
    has_commandes() {
      return this.list_commandes.length > 0;
    }
  },
  async mounted() {
    this.fiche_coureur = await UserService.getFiche(this.mainStore.module.id);
  },
};
</script>

<style lang="scss" scoped></style>